module.exports = __webpack_public_path__ + "static/media/texture.55db9915.png";